/**
 * Cust product template: Checkout button
 * Adds current variant (+ checked add-ons) at form quantity, then goes to /checkout.
 */
(function () {
  if (window.__custProductCheckoutBtnBound) return;
  window.__custProductCheckoutBtnBound = true;

  function getProductForm() {
    return document.querySelector('.section-cust-product-template form.product-form') ||
      document.querySelector('.section-cust-product-template .product-form') ||
      document.querySelector('form.product-form');
  }

  function getMainQuantity(form) {
    var root = form || document;
    var inputs = root.querySelectorAll('.product-form__input--quantity');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.closest('.custom-variant-item')) continue;
      if (input.name && input.name !== 'quantity') continue;
      var qty = parseInt(input.value, 10);
      return qty > 0 ? qty : 1;
    }
    return 1;
  }

  function getMainVariantId(form) {
    var turnkeyState = window.turnkeyInstallationState || {};
    var hasTurnkeyBlock = !!document.querySelector('.turnkey-installation-block');
    if (hasTurnkeyBlock && turnkeyState.enabled && turnkeyState.finalVariantId) {
      return turnkeyState.finalVariantId;
    }
    var selector = (form && form.querySelector('.product-form__variants')) ||
      document.querySelector('.product-form__variants');
    return selector ? selector.value : null;
  }

  function getFormProperties(form) {
    var properties = {};
    if (!form) return properties;
    form.querySelectorAll('[name*=properties]').forEach(function (item) {
      var propName = item.getAttribute('data-property-name');
      if (propName) properties[propName] = item.value;
    });
    return properties;
  }

  function collectAddonItems() {
    var items = [];
    document.querySelectorAll('.section-product-template .custom-variant-item input:checked').forEach(function (inputChecked) {
      var variantItem = inputChecked.closest('.custom-variant-item');
      if (!variantItem || !variantItem.dataset.variantId) return;

      var quantity = 1;
      var qtyInput = variantItem.querySelector('.product-form__input--quantity');
      if (qtyInput) {
        if (qtyInput.name === 'expand-capacity-quantity') {
          var checkedExpand = variantItem.querySelector("input[name='expand-capacity-quantity']:checked");
          quantity = checkedExpand ? parseInt(checkedExpand.value, 10) || 1 : 1;
        } else {
          quantity = parseInt(qtyInput.value, 10) || 1;
        }
      }

      if (variantItem.dataset.shipping) {
        items.push({
          id: variantItem.dataset.variantId,
          quantity: quantity,
          properties: { Shipping: variantItem.dataset.shipping }
        });
      } else {
        items.push({
          id: variantItem.dataset.variantId,
          quantity: quantity
        });
      }
    });
    return items;
  }

  function collectAccessoryItems(variantId, qty) {
    var items = [];
    var accessoriesWrap = document.querySelector('.product-accessories-section[data-variant="' + variantId + '"]');
    if (!accessoriesWrap) return items;
    accessoriesWrap.querySelectorAll('.variant-accessory.selected').forEach(function (elem) {
      var id = elem.getAttribute('data-variant-id');
      if (id) items.push({ id: id, quantity: qty });
    });
    return items;
  }

  function setLoading(btn, loading) {
    var text = btn.querySelector('[data-checkout-btn-text]');
    var loader = btn.querySelector('[data-checkout-loader]');
    btn.disabled = loading;
    btn.classList.toggle('is-loading', loading);
    if (text) text.classList.toggle('hide', loading);
    if (loader) loader.classList.toggle('hide', !loading);
  }

  function buildItems(form) {
    var variantId = getMainVariantId(form);
    if (!variantId) return null;

    var turnkeyState = window.turnkeyInstallationState || {};
    var hasTurnkeyBlock = !!document.querySelector('.turnkey-installation-block');
    if (hasTurnkeyBlock && turnkeyState.enabled && !turnkeyState.hasValidFee) {
      return { error: turnkeyState.notSelectVariantError || turnkeyState.defaultError || 'Please complete installation information first.' };
    }

    var qty = getMainQuantity(form);
    var items = [];
    items = items.concat(collectAccessoryItems(variantId, qty));
    items.push({
      id: variantId,
      quantity: qty,
      properties: getFormProperties(form)
    });
    items = items.concat(collectAddonItems());
    return { items: items };
  }

  function goCheckout() {
    window.location.href = '/checkout';
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.cust-product-checkout-btn');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    var form = btn.closest('form') || getProductForm();
    var payload = buildItems(form);
    if (!payload) return;
    if (payload.error) {
      window.alert(payload.error);
      return;
    }

    setLoading(btn, true);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: payload.items })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok || result.json.status === 422) {
          setLoading(btn, false);
          var message = (result.json && (result.json.description || result.json.message)) || 'Unable to checkout';
          window.alert(message);
          return;
        }
        if (window.enablePromotionsUsingCode || window.autoPromotionsEnable) {
          window.cart_clear = false;
          if (typeof window.promotionValidate === 'function') {
            window.promotionValidate();
          }
        }
        goCheckout();
      })
      .catch(function () {
        setLoading(btn, false);
        window.alert('Unable to checkout');
      });
  });
})();
